import { Component } from '@angular/core';

@Component({
  selector: 'uni-widget-content-subtitle',
  templateUrl: './uni-widget-content-subtitle.component.html',
  styleUrls: ['./uni-widget-content-subtitle.component.scss'],
})
export class UniWidgetContentSubtitleComponent {
}
